var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"expande-horizontal centraliza wrap"},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"expande-horizontal"},[(_vm.get_checkout.method === 'card')?_c('CardMethod'):_vm._e(),(_vm.get_checkout.method === 'bank_slip')?_c('BankSlipMethod'):_vm._e()],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }